import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * The merge knows Tailwind's radius names and not the ones `index.css` adds by
 * job. Without these, `rounded-control` and a caller's `rounded-inset` both
 * stayed on the element, and the stylesheet's order chose the token.
 */
const twMerge = extendTailwindMerge({
  extend: { theme: { radius: ["control", "inset", "menu"] } },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
